// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__xjzGi","wrapper":"style__wrapper__18YnF"};